module.exports = __webpack_public_path__ + "img/shareBgH5.cd5096df.png";